import { FormMessage, FormMessageVariant } from '@aus-platform/design-system';

export const HraGuide = () => {
  return (
    <div className="guide-page map-3d-sidebar-content">
      <ul>
        <li>
          <span>Step 1 - </span>
          <p>
            Go to <strong>Generate</strong> tab.
          </p>
        </li>
        <li>
          <span>Step 2 - </span>
          <p>
            Provide a name for your haul road. This will help you find it later
            under the <strong>Outputs</strong> tab.
          </p>
        </li>
        <li>
          <span>Step 3 - </span>
          <p>
            Select <strong>Haul Road Edges Layer</strong> from your workspace
            that contains two line features. These lines represent both the
            edges of your haul road.
          </p>
        </li>
        <li>
          <span>Step 4 - </span>
          <p>
            Select a <strong>Haul Road Type</strong>.
          </p>
        </li>
        <li>
          <span>Step 5 - </span>
          <p>
            Fill in <strong>Vehicle Width</strong> - Width of the vehicle that
            will use the road.
          </p>
        </li>
        <li>
          <span>Step 6 - </span>
          <p>
            Fill in <strong>Vehicle Tyre Height</strong> - Height of the
            vehicle's tyre that will use the road.
          </p>
        </li>
        <li>
          <span>Step 7 - </span>
          <p>
            Fill in <strong>Chainage Interval</strong>.
          </p>
        </li>
        <li>
          <span>Step 8 - </span>
          <p>
            If your haul road includes a median (such as a divider), select a
            polygon layer from the workspace that represents it.
          </p>
        </li>
        <li>
          <span>Step 9 - </span>
          <p>
            Click <strong>Generate Haul Road</strong> to process the inputs.
            Generation will take 10–15 mins.
          </p>
        </li>
        <li>
          <span>Step 10 -  </span>
          <p>
            View result in <strong>Outputs</strong> tab.
          </p>
        </li>
      </ul>
      <FormMessage
        variant={FormMessageVariant.Info}
        message="Users must have access to at least one haul road layer to view the haul road entity in outputs. Haul road entity access follows the access control defined at the layer level."
      />
    </div>
  );
};
